'use client';

// Page transition component - simplified since Next.js handles navigation natively
// The loading indicator is no longer needed with proper client-side routing
export default function PageTransition() {
  return null;
}
